export interface MultiplexPeakDetectionChannelProfile {
  threshold: number;
  minDistancePx: number;
  minRadiusUm?: number | null;
  maxRadiusUm?: number | null;
}

export interface MultiplexRawDogPeakDetectionChannelProfile {
  minDistancePx: number;
  minContrast: number;
  minDogZ: number;
  candidateZ: number;
  spotSigmaPx: number;
  backgroundSigmaPx: number;
  minRadiusUm: number | null;
  maxRadiusUm: number | null;
  clipMaxFraction: number;
  clipMinFraction: number;
}

export type MultiplexPeakDetectionProfile =
  | MultiplexPeakDetectionChannelProfile
  | MultiplexRawDogPeakDetectionChannelProfile;

export interface PanelPeakDetectionConfiguration {
  channelNames: string[];
  useRawDog: boolean;
  defaultProfile: MultiplexPeakDetectionProfile;
  overrides: Array<{ channelNames: string[]; profile: MultiplexPeakDetectionProfile }>;
}

export interface MultiplexPeakDetectionJobConfig {
  channelNames: string[];
  profiles: Record<string, MultiplexPeakDetectionProfile>;
  threshold?: number;
  minDistancePx?: number;
  resolutionUmpp?: number | null;
  normalizationName?: string | null;
  useRawDog: boolean;
}

export interface MultiplexPeakDetectionFormValues {
  jobName: string;
  jobDescription: string;
  configParams: MultiplexPeakDetectionJobConfig;
}

export enum RunMultiplexPeakDetectionStep {
  LoadParams = 'Reuse Previous Job Settings',
  NameAndDescription = 'Name and Description',
  Configuration = 'Configuration',
  Advanced = 'Advanced',
}

export const runMultiplexPeakDetectionStepsOrder = [
  RunMultiplexPeakDetectionStep.LoadParams,
  RunMultiplexPeakDetectionStep.NameAndDescription,
  RunMultiplexPeakDetectionStep.Configuration,
  RunMultiplexPeakDetectionStep.Advanced,
];

export const multiplexPeakDetectionDefaultThreshold = 0.06;
export const multiplexPeakDetectionDefaultMinDistancePx = 3;
export const multiplexRawDogPeakDetectionDefaults: MultiplexRawDogPeakDetectionChannelProfile = {
  minDistancePx: 3,
  minContrast: 0.048,
  minDogZ: 4,
  candidateZ: 1.5,
  spotSigmaPx: 1.2,
  backgroundSigmaPx: 6,
  minRadiusUm: null,
  maxRadiusUm: null,
  clipMaxFraction: 0.97,
  clipMinFraction: 0.03,
};
